import { render, staticRenderFns } from "./CartaoAprovadores.vue?vue&type=template&id=5502344e&scoped=true"
import script from "./CartaoAprovadores.vue?vue&type=script&setup=true&lang=js"
export * from "./CartaoAprovadores.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CartaoAprovadores.vue?vue&type=style&index=0&id=5502344e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5502344e",
  null
  
)

export default component.exports